// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { costCodesStyles } from "@insite/content-library/Widgets/Budget/CostCodes";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

costCodesStyles.cancelButton = {
    variant: "secondary",
};

costCodesStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        button {
            display: inline-block;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: flex-start;
                `,
                css`
                    justify-content: flex-start;
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
            ])}
    `,
};
